export const getNumbers = (num) => {
  let str = num.toString();

  const number = str.replace(/[^0-9]/g, "");

  return +number;
};
